import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import NotFound from '../pages/NotFound';

// Retired URLs (old /foundations/* paths and merged guides) resolve to their new
// home. The static host cannot issue a real 301, so crawlers get the canonical
// and meta-refresh in the prerendered snapshot and browsers get this redirect.
export const MovedRedirect = () => {
  const { pathname } = useLocation();
  const [target, setTarget] = useState(undefined); // undefined = looking up

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get('/knowledge/redirects');
        if (!active) return;
        const hit = (data.redirects || []).find((r) => r.from_path === pathname);
        setTarget(hit ? hit.to_path : null);
      } catch {
        if (active) setTarget(null);
      }
    })();
    return () => { active = false; };
  }, [pathname]);

  if (target === undefined) {
    return (
      <div className="w-full flex items-center justify-center py-space-3xl" data-testid="moved-lookup">
        <span className="inline-block w-2 h-2 rounded-full bg-surface-tint animate-pulse" />
        <span className="ml-space-sm font-label-md text-label-md uppercase tracking-wider text-on-surface-variant">Taking you to the new page…</span>
      </div>
    );
  }
  if (!target) return <NotFound />;
  return <Navigate to={target} replace />;
};

export default MovedRedirect;
